module.exports = __webpack_public_path__ + "static/media/Hydrogen.77afbac6.png";